import { Injectable, inject, signal } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private readonly http = inject(HttpClient);

  readonly currentDataSignal = signal<string>('Initial Value');
  readonly currentGroupDataSignal = signal<string[]>([]);
  readonly printDataSignal = signal<any>({});
  readonly showMaintabsSignal = signal<boolean>(true);

  // Backward-compatible observable API for existing subscribers.
  currentData = toObservable(this.currentDataSignal);
  currentGroupData = toObservable(this.currentGroupDataSignal);
  printData$ = toObservable(this.printDataSignal);
  showMaintabs$ = toObservable(this.showMaintabsSignal);

  constructor() { }

  updateData(data: string) {
    this.currentDataSignal.set(data);
  }

  updateUserGrps(data: any[]) {
    this.currentGroupDataSignal.set(data);
  }

  updatePrintData(data: any) {
    this.printDataSignal.set(data);

  }
  updateShowMaintabs(data: boolean) {
    this.showMaintabsSignal.set(data);
  }
  handleError<T>() {
    return (error: HttpErrorResponse): Observable<T> => {
      let errorMessage = error.headers.get("message");
      let statusCode = error.status.valueOf();
      if ((error.error) && error.error.message) {
        errorMessage = error.error.message
      }
      const errors = { status: statusCode, error: errorMessage };
      return throwError(() => errors);
    };
  }
  isUserActive(userId: string): Observable<{ isActive: boolean; message: string }> {    
    const url = `${env.diaBasePath}updateAndFetchUserStatus`;
    return this.http.post<{ isActive: boolean; message: string }>(url, { userId }).pipe(
      map((res: any) => {
        return ({
          isActive: res?.body?.isActive,
          message: res?.body?.message
        })
      }),
      catchError((error: any) => {
        return of({
          isActive: error.error?.body?.isActive,
          message: error.error?.body?.message
        })

      })
    );
  }
}
